import React from "react";
import { Link } from "react-router-dom";
import { Medallion } from "@/components/CompassMark";

export const ArtifactsAcknowledgementsPreview = () => {
  return (
    <section data-testid="home-artifacts-preview" className="bg-ink-surface py-24 md:py-36 border-t border-ink-line">
      <div className="container-edge">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6 flex justify-center lg:justify-start">
            <Medallion size={420} className="max-w-[80vw] drop-shadow-[0_30px_60px_rgba(0,0,0,0.6)]" />
          </div>
          <div className="lg:col-span-6">
            <p className="eyebrow-gold mb-5">Artifacts · Acknowledgements</p>
            <h2 className="display-serif text-3xl md:text-5xl text-paper-primary text-balance leading-[1.05]">
              What you say you are is what survives reality.
            </h2>
            <p className="mt-6 max-w-xl font-serif text-lg text-paper-secondary leading-relaxed text-pretty">
              Evolution is preserved here. Old logos. Drafts that did not earn permanence. Names of people who shaped the standards.
              The archive trusts the long horizon more than the launch.
            </p>
            <div className="mt-10 flex flex-wrap gap-5">
              <Link to="/artifacts" className="btn-quiet" data-testid="home-cta-artifacts">
                <span>Browse the artifacts</span>
              </Link>
              <Link to="/acknowledgements" className="btn-arrow" data-testid="home-cta-ack">
                <span>The people behind the work</span>
                <span className="arrow">→</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArtifactsAcknowledgementsPreview;
